module.exports = {"apiUrl":"https://scan.emailsecuritycheck.service.ncsc.gov.uk"};